/**
 * LiveKit service utility for token fetching
 */

/**
 * Fetch LiveKit token from backend
 * @param {string} tokenUrl - URL to fetch token from (optional, defaults to production URL)
 * @param {string} userId - Supabase user id. Passed through as the LiveKit participant
 *   identity so agent-service can later match an inattentiveness event's user_id back to
 *   this specific room (needed for routing to work correctly with concurrent sessions).
 * @returns {Promise<{token: string, url: string}>}
 */
export async function fetchLiveKitToken(tokenUrl = null, userId = null) {
  try {
    // Use environment variable if set, otherwise use relative URL (proxied by nginx)
    // In production, this will be proxied to the livekit-token-server service
    const base = tokenUrl ||
                process.env.REACT_APP_LIVEKIT_TOKEN_URL ||
                '/api/livekit/token';
    const url = userId ? `${base}?user_id=${encodeURIComponent(userId)}` : base;

    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch token: ${res.statusText}`);
    }
    const data = await res.json();
    return {
      token: data.token,
      url: data.url
    };
  } catch (error) {
    console.error('Error fetching LiveKit token:', error);
    throw error;
  }
}

